import { find, get } from "lodash";
import { MDBContainer, MDBSpinner } from "mdbreact";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import { currentEnv } from "~/configs";
import { partnerInfo } from "~/configs/partnerDetails";
import styles from "./style.module.scss";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

class RegisterForPersonal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
  }

  hideSpinner = () => {
    console.log("1 :>> ", 1);
    this.setState({
      loading: false
    });
  };

  render() {
    return (
      <MDBContainer>
        <span className={styles.formTitle}>Nhập thông tin cá nhân</span>
        {this.state.loading ? (
          <div className="loading">
            <MDBSpinner big />
          </div>
        ) : null}

        <iframe
          id="myiFrame"
          height="100%"
          width="100%"
          onLoad={() => this.hideSpinner()}
          // scrolling="no"
          className={styles.formInfo}
          src={`${currentEnv.LINK_API_COVID19}/vaccine-form/dang-ky.xhtml?background=fff&showSuccess=true`}
          title="ĐĂNG KÝ KHAI BÁO CÁ NHÂN"
        />
      </MDBContainer>
    );
  }
}

const RegisterForPersonalHelmet = withTitle({
  component: RegisterForPersonal,
  title: `${hospitalName.value} | ĐĂNG KÝ KHAI BÁO CÁ NHÂN`
});

export default connect(null, null)(RegisterForPersonalHelmet);
